import CloseIcon from 'common/components/svg-icon/close';
import styles from './styles.less';
import { observer } from 'mobx-react';


const SearchResultPropType = React.PropTypes.shape({
    query: React.PropTypes.string,
    total: React.PropTypes.number
});


function ClipSearchResults(props) {
    const total = parseInt(props.searchResults.total, 10);
    if (isNaN(total)) return null;
    return (
        <div className={ cx(styles.root, props.className) }>
            <button
                className={ styles.clearButton }
                onClick={ props.onClearSearch }>
                <CloseIcon className={ styles.closeIcon } />
            </button>
            <span>
                { total } results for <strong className={ styles.query }>{ props.searchResults.query }</strong>
            </span>
        </div>
    );
}

ClipSearchResults.propTypes = {
    onClearSearch: React.PropTypes.func.isRequired,
    searchResults: SearchResultPropType.isRequired
};


export { SearchResultPropType };
export default observer(ClipSearchResults);



// WEBPACK FOOTER //
// ./src/show-page/components/clip-search-results/index.js